import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';

import { DataService } from '../../shared-service/data.service';
import { BaseService } from '../../shared-service/base.service';

declare var $: any;

@Component({
  selector: 'app-reset-node',
  templateUrl: './reset-node.component.html',
  styleUrls: ['./reset-node.component.css']
})
export class ResetNodeComponent implements OnInit, AfterViewInit {

  @Output() acceptClick = new EventEmitter<object>();
  itemData: object|any;
  @Input() scope: string = "";
  ReasonForReset: string = "";
  parentNodeName: string = "";
  NodeName: string = "";
  options: object = {
    keyboard: true,
    backdrop: true,
    show: true
  }

  constructor(public dataService: DataService, public bs: BaseService) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
  }

  openModelPopup(itemData: object, IsAnnouncement: boolean, parentNodeName: string) {
    $("#btnAccept" + this.scope).prop("disabled", false);
    $("#btnAccept" + this.scope).css("background", "#ffffff");
   this.itemData = itemData;
    this.parentNodeName = parentNodeName;
    this.NodeName = this.itemData['NodeName'];
    $('#esignModal' + this.scope).modal(this.options);

  }

  IsEsignPopupOpen(): boolean {
    return $('#esignModal' + this.scope).is(':visible');
  }

  closePanel() {
    $('#esignModal' + this.scope).modal('hide');
    $("#txtRttmptsRqstRsn" + this.scope).val('');
  }

  ResetNodeReAttemptsRequest() {
    $("#btnAccept" + this.scope).prop("disabled", "disabled");
    $("#btnAccept" + this.scope).css("background", "#eee");
    this.ReasonForReset = $("#txtRttmptsRqstRsn" + this.scope).val();
    if (this.ReasonForReset.length != 0 || this.ReasonForReset != '') {
      this.itemData['ReasonForResetReattempst'] = this.ReasonForReset;
      this.acceptClick.emit(this.itemData);
    }
    else
      alert(this.bs.getResource('rbkey_RsnFrdReAttmptRqstInvldMSG'));
    $("#btnAccept" + this.scope).prop("disabled", false);
    $("#btnAccept" + this.scope).css("background", "#ffffff");
  }

}
